// extracted by mini-css-extract-plugin
module.exports = {"heading":"FAQItemFiltered_heading__BUn6d","highlighted":"FAQItemFiltered_highlighted__lRkOd","content":"FAQItemFiltered_content__6Oen1"};